module.exports = __webpack_public_path__ + "308aa4a69d97d99ccfcc32dbe82b4522.MP3";